export default __webpack_public_path__ + "7b33ab9db0cd306aa76a951d418d9b8d.svg";